import React, { useState, useEffect } from 'react';
import {
  useLocation
} from 'react-router-dom';

import application from 'application';
import internalEventCodes from 'event-system/codes/internal';
import menuEventCodes from 'constants/menu-event-codes';

import { cloneMenuList } from 'utilities';
import { getInitialMenuCueState } from './utilities';

import NavItem from 'generics/components/nav-item';

import { ReactComponent as AnalyticsIcon } from 'assets/images/quick-access-analytics-icon.svg';
import { ReactComponent as PagesIcon } from 'assets/images/quick-access-pages-icon.svg';
import { ReactComponent as CommunityIcon } from 'assets/images/quick-access-community-icon.svg';
import { ReactComponent as CustomersIcon } from 'assets/images/quick-access-customers-icon.svg';
import { ReactComponent as InboxIcon } from 'assets/images/quick-access-inbox-icon.svg';
import { ReactComponent as CampaignsIcon } from 'assets/images/campaigns-menu-icon.svg';
import { ReactComponent as PartnersIcon } from 'assets/images/quick-access-partners-icon.svg';
import { ReactComponent as PaymentsIcon } from 'assets/images/finance-menu-icon.svg';
import { ReactComponent as TasksIcon } from 'assets/images/tasks-menu-icon.svg';
import { ReactComponent as DatabasesIcon } from 'assets/images/databases-menu-icon.svg';
import { ReactComponent as ProductsIcon } from 'assets/images/products-menu-icon.svg';
import { ReactComponent as AssistantIcon } from 'assets/images/ask-ai-medium-icon.svg';
import { ReactComponent as SkillsIcon } from 'assets/images/skills-icon.svg';

import './index.scss';

function StartupNavigation(props) {

  const location = useLocation();

  const [menuList, setMenuList] = useState(cloneMenuList(application.menuList));
  const [menuCueState, setMenuCueState] = useState(getInitialMenuCueState(application.menuList));

  function setMenuItemHoverStateByIndex(index, hoverState) {

    const _menuList = cloneMenuList(menuList);

    _menuList[index].hoverState = hoverState;

    setMenuList(_menuList);

  }

  function renderNavigationElement(link, index) {

    const linkAttributes = {
      location,
      ...link,
      to: link.path,
      activeClassName: 'active',
      parentClassName: 'link',
      href: link.path,
      onMouseEnter() {
        setMenuItemHoverStateByIndex(index, true);
      },
      onMouseLeave() {
        setMenuItemHoverStateByIndex(index, false);
      },
      onClick(event) {
        setTimeout(() => {
          application.eventSystem.internal.emit('RESET_MIDDLE_PANEL_EXPANDED', {});
        }, 1);
      }
    };

    const navigationLinkBoxAttributes = {
      className: 'navigation-link-hover-shade-box',
      onClick: props.onOptionClick
    };

    const atagAttributes = {
      className: link.className,
      href: link.path
    };

    if (link.disabled === true) {
      linkAttributes.className += atagAttributes.className += ' disabled-link';
      linkAttributes.title = atagAttributes.title = link.disabledText;
    }

    return <NavItem key={index} {...linkAttributes}>
      <div {...navigationLinkBoxAttributes}>
        {renderCueElement(link.name)}
        {renderIconByName(index, link.name)}
        <span className="navigation-link-name">{link.name}</span>
      </div>
    </NavItem>;

  }

  function renderCueElement(menuItemName) {

    if (menuCueState[menuItemName] === false) {
      return;
    }

    return <div className="navigation-cue"></div>;

  }

  function renderIconByName(index, menuItemName) {

    const menuItem = menuList[index];

    if (menuItem.name === 'Community') {
      return <CommunityIcon />;
    }

    // if (menuItem.name === 'Analytics') {
    //   return <AnalyticsIcon />;
    // }

    if (menuItem.name === 'Contacts') {
      return <CustomersIcon />;
    }

    if (menuItem.name === 'Pages') {
      return <PagesIcon />;
    }

    if (menuItem.name === 'Partners') {
      return <PartnersIcon />;
    }

    if (menuItem.name === 'Campaigns') {
      return <CampaignsIcon />;
    }

    if (menuItem.name === 'Inbox') {
      return <InboxIcon />;
    }

    if (menuItem.name === 'Analytics') {
      return <AnalyticsIcon id="analytics-menu-icon"/>;
    }

    if (menuItem.name === 'Finance') {
      return <PaymentsIcon id="finance-menu-icon"/>;
    }

    if (menuItem.name === 'Tasks') {
      return <TasksIcon id="tasks-menu-icon"/>;
    }

    if (menuItem.name === 'Databases') {
      return <DatabasesIcon id="databases-menu-icon"/>;
    }

    if (menuItem.name === 'Products') {
      return <ProductsIcon id="products-menu-icon"/>;
    }

    if (menuItem.name === 'Assistant') {
      return <AssistantIcon id="assistant-menu-icon"/>;
    }

    if (menuItem.name === 'Skills') {
      return <SkillsIcon id="skills-menu-icon"/>;
    }

  }

  function renderMenuList() {

    if (menuList.length === 0) {
      return;
    }

    const menuListLength = menuList.length;
    const elements = [];

    for (let index = 0; index < menuListLength; index++) {

      const menuItem = { ...menuList[index] };

      const link = renderNavigationElement(menuItem, index);
      elements.push(link);

    }

    return <nav id="startup-navigation">
      <div id="startup-navigation-list" className="helptap-list">
        {elements}
      </div>
    </nav>;

  }

  function registerMenuListChangedEventHandler() {

    function handleMenuListChangedEvent() {

      setMenuList(cloneMenuList(application.menuList));

    }

    application.eventSystem.internal.on(menuEventCodes.MENU_LIST_CHANGED, handleMenuListChangedEvent);

    return function unregisterMenuListChangedEventHandler() {
      application.eventSystem.internal.off(menuEventCodes.MENU_LIST_CHANGED, handleMenuListChangedEvent);
    };

  }

  useEffect(function registerNavigationQueueEvents() {

    const eventUnregisters = [
      registerShowNavigationQueueEventHandler(),
      registerHideNavigationQueueEventHandler(),
      registerMenuListChangedEventHandler()
    ];

    return function unregisterNavigationQueueEvents() {

      for (let eventUnregister of eventUnregisters) {
        eventUnregister();
      }

    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function registerShowNavigationQueueEventHandler() {

    function handleShowNavigationQueueEvent(data) {

      setMenuCueState(function updateMenuCueState(menuCueState) {

        return {
          ...menuCueState,
          [data.menuItemName]: true
        };

      });

    }

    application.eventSystem.internal.on(internalEventCodes.SHOW_NAVIGATION_CUE, handleShowNavigationQueueEvent);

    return function unregisterShowNavigationQueueEventHandler() {
      application.eventSystem.internal.off(internalEventCodes.SHOW_NAVIGATION_CUE, handleShowNavigationQueueEvent);
    };

  }

  function registerHideNavigationQueueEventHandler() {

    function handleHideNavigationQueueEvent(data) {

      setMenuCueState(function updateMenuCueState(menuCueState) {

        return {
          ...menuCueState,
          [data.menuItemName]: false
        };

      });

    }

    application.eventSystem.internal.on(internalEventCodes.HIDE_NAVIGATION_CUE, handleHideNavigationQueueEvent);

    return function unregisterHideNavigationQueueEventHandler() {
      application.eventSystem.internal.off(internalEventCodes.HIDE_NAVIGATION_CUE, handleHideNavigationQueueEvent);
    };

  }

  return <div id="startup-navigation-main">
    {renderMenuList()}
  </div>;

}

export default StartupNavigation;